export enum ChoicesStatusConsumptionBag {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CONSUMED = 'consumed',
}

export interface IConsumptionBag {
  _id: string;
  name: string;
  organization: {
    _id: string;
    name: string;
  };
  legalEntity?: {
    _id: string;
    legal_name: string;
  };
  totalAmount: number;
  consumedAmount: number;
  availableAmount: number;
  currentBalance: number;
  expirationDate: Date | string;
  status: ChoicesStatusConsumptionBag;
  sku?: {
    _id: string;
    name: string;
    label: string;
  };
  allowedItems: {
    product: string;
    sku: string;
    allowedAmount: number;
    consumedAmount: number;
  }[];
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export interface IConsumptionBagTransformed extends IConsumptionBag {
  label: string;
  code?: string;
  isExpired: boolean;
  isActive: boolean;
  hasBalance: boolean;
}
